<template>
    <span 
            class="text-danger field-validation-error"  
            data-valmsg-replace="true"
            v-bind:data-valmsg-for="fieldName"
    >
        <span>
            {{ message }}
        </span>
    </span>
</template>

<script>
    export default {
        name: "error-message",
        props: {
            message: {
                type: String,
                required: true
            },
            fieldName: {
                type: String,
                required: false
            }
        }
    }
</script>
